import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import { storeReducers, StoreState } from './store';
import { connectRouter } from 'connected-react-router';
import logger from 'redux-logger';

export function configureStore (history: any, initialState: StoreState) {
  const middleware = [thunkMiddleware, routerMiddleware(history)];
  const rootReducer = combineReducers({
    router: connectRouter(history),
    ...storeReducers,
  });

  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    (window as any).devToolsExtension
  ) {
    // Log redux actions on console
    middleware.push(logger)
  }

  return createStore(
    rootReducer,
    initialState as any,
    composeEnhancers(applyMiddleware(...middleware)),
  );
}

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
